<template>
  <div>
    <div class="homepage-container">
      <v-card class="homepage-card">
        <v-card-text>
          <div style="align-items: baseline" class="mb-lg-2">
            <div style="text-align: center">
              <img :src="logoUrl" alt="Avatar" style="width: 16vw"><br><span class="homepage app-name-panel"> AVAILABLE SERVICES</span>
              <!--                            <div class="homepage app-name-panel">AVAILABLE ONLINE VISA SERVICES</div>-->
            </div>
            <!--                        <div class="mt-2 justify-center" style="display: flex; margin-bottom: 13px;">-->

            <!--                        </div>-->
          </div>
          <div class="homepage-services">
            <div class="row">
              <!--              <div class="col-12 text-center">-->
              <!--                <span class="homepage-service-name-panel text-uppercase">Online Visa Services</span>-->
              <!--              </div>-->

              <!--              <homepage-item @click.native="selectCard('pre-arrival')"-->
              <!--                             title="Visa Pre-Arrival"-->
              <!--                             service_icon="ic_online.png"-->
              <!--                             sub_title="Before arriving in Nepal"-->
              <!--                             info="Apply for Visa online before arriving in Nepal"-->
              <!--                             redirection_link="/online"-->
              <!--                             :style="selectedCard=='pre-arrival'?styleObject:''">-->
              <!--              </homepage-item>-->

              <v-flex md3 class="pa-2" :style="selectedCard=='on-arrival'?styleObject:''">
                <v-card raised @click="showOfficeDialog('on-arrival')" target="_blank"
                        class="mx-auto">
                  <v-list-item class="py-3">
                    <!--                <v-icon  height="45" :src="service_icon"/>-->
                    <img height="40"
                         :src="require('@/assets/visa-services/ic_visa_on_arrival.png')"/>
                    <v-list-item-content class="ml-4">
                      <v-list-item-title class="headline"><span
                          style="font-size: 17px;color: #0065D8; font-weight: bold">Visa On-arrival</span>
                      </v-list-item-title>
                      <v-list-item-subtitle><span
                          style="font-size: 13px;font-weight: bold; color: #E7492E;">After arriving in Nepal</span>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item-subtitle class="pl-4 pb-3 pt-1">
                    <v-icon class="">mdi-hand-pointing-right</v-icon>
                    <span style="color: #000000; font-weight: bold; font-style: normal;font-size: 12px;">Apply for Visa at Terminal after arriving in Nepal</span>
                  </v-list-item-subtitle>
                </v-card>
              </v-flex>

              <!--              <homepage-item @click.native="selectCard('visa-from-mission')"-->
              <!--                             title="Visa From Nepalese Mission"-->
              <!--                             service_icon="ic_visa_embassy.png"-->
              <!--                             sub_title="Visa application at Diplomatic Mission"-->
              <!--                             info="Apply for Visa at Embassy/Mission/Consulate"-->
              <!--                             direction_link="/onlinevisa-mission/application"-->
              <!--                             :style="selectedCard=='visa-from-mission'?styleObject:''"-->
              <!--              ></homepage-item>-->
              <homepage-item @click.native="selectCard('visa-from-mission')"
                             title="Visa From Nepalese Mission"
                             service_icon="ic_visa_embassy.png"
                             sub_title="Visa application at Diplomatic Mission"
                             info="Apply for Visa at Embassy/Mission/Consulate"
                             :redirection_link="getRedirectionLink('visa-from-mission')"
                             :style="selectedCard=='visa-from-mission'?styleObject:''"
              ></homepage-item>
              <!--              redirection_link="https://nepaliport-new.immigration.gov.np/online-visa-missionManage/application"-->
              <!--              redirection_link="/onlinevisa-mission"-->
              <homepage-item @click.native="selectCard('eta-visa-processing')"
                             title="Electronic Travel Authorization"
                             service_icon="ic_entry_visa.png"
                             sub_title="Visa application for ETA"
                             info="Apply for ETA online before arriving in Nepal"
                             :redirection_link="getRedirectionLink('eta-visa-processing')"
                             :style="selectedCard == 'eta-visa-processing' ? styleObject : ''"
              ></homepage-item>
              <!--      redirection_link="/eta-visa-processing"        -->
              <!--              redirection_link="https://nepaliport-new.immigration.gov.np/eta-visa-processing/application"-->


              <homepage-item @click.native="selectCard('visa-extension')"
                             title="Visa Extension"
                             service_icon="ic_visa_extension.png"
                             sub_title="Extending current visa"
                             info="Extend the current visa"
                             :redirection_link="getRedirectionLink('visa-extension')"
                             :style="selectedCard=='visa-extension'?styleObject:''"
              ></homepage-item>

            </div>
            <!--            redirection_link="https://nepaliport-new.immigration.gov.np/visa-processing/extension"-->
            <!--            redirection_link="/visa-processing?tab=tab-extend"-->
            <div class="row mt-2">

              <homepage-item @click.native="selectCard('visa-conversion')"
                             title="Visa Conversion"
                             sub_title="Converting to another visa type"
                             info="Convert one type of Visa to another"
                             service_icon="ic_visa_conversion.png"
                             :redirection_link="getRedirectionLink('visa-conversion')"
                             :style="selectedCard=='visa-conversion'?styleObject:''"
              ></homepage-item>
              <!--              redirection_link="/visa-processing?tab=tab-change"-->
              <!--              redirection_link="https://nepaliport-new.immigration.gov.np/visa-processing/conversion"-->

              <homepage-item @click.native="selectCard('visa-transfer')"
                             title="Visa Transfer"
                             service_icon="ic_visa_transfer.png"
                             sub_title="Transferring visa to another document"
                             info="Transfer visa to another another passport,td,etc."
                             :redirection_link="getRedirectionLink('visa-transfer')"
                             :style="selectedCard=='visa-transfer'?styleObject:''"
              ></homepage-item>
              <!--              redirection_link="/visa-processing?tab=tab-transfer"-->


              <homepage-item @click.native="selectCard('entry-visa')"
                             title="Entry Visa"
                             service_icon="ic_entry_visa.png"
                             sub_title="Entry Tourist Visa "
                             info="Apply for Entry Tourist Visa"
                             :redirection_link="getRedirectionLink('entry-visa')"
                             :style="selectedCard=='entry-visa'?styleObject:''"
              ></homepage-item>
              <!--              redirection_link="https://nepaliport-new.immigration.gov.np/entry-visa-processing"-->
              <!--              redirection_link="/entry-visa-processing"-->

              <homepage-item @click.native="selectCard('visa-plan-upgrade')"
                             title="Visa Plan Upgrade"
                             service_icon="ic_plan_upgrade.png"
                             sub_title="Visa Plan Upgrade"
                             info="Upgrade visa plan to SRE/MRE"
                             :redirection_link="getRedirectionLink('visa-plan-upgrade')"
                             :style="selectedCard=='visa-plan-upgrade'?styleObject:''"
              ></homepage-item>
              <!--              redirection_link="https://nepaliport-new.immigration.gov.np/visa-processing/upgrade"-->
              <!--              redirection_link="/visa-processing?tab=tab-upgrade"-->
            </div>
            <div class="row mt-2">
              <!--              <div class="col-12 text-center">-->
              <!--                <span class="homepage-service-name-panel text-uppercase">A/D Certification & Application Track</span>-->
              <!--              </div>-->

              <homepage-item @click.native="selectCard('arrival-departure')"
                             title="Arrival/Departure Certification"
                             service_icon="ic_visa_embassy.png"
                             sub_title="Arrival/Departure certification"
                             info="Certify for Arrival/Departure"
                             :redirection_link="getRedirectionLink('arrival-departure')"
                             :style="selectedCard=='arrival-departure'?styleObject:''"
              ></homepage-item>
              <!--              redirection_link="/visa-processing?tab=tab-arrival"-->
              <!--              redirection_link="https://nepaliport-new.immigration.gov.np/visa-processing/arrival"-->


              <homepage-item @click.native="selectCard('non-visa-arrival-departure')"
                             title="Non Visa Arrival/Departure Certification"
                             service_icon="ic_visa_embassy.png"
                             sub_title="Non Visa Arrival/Departure certification"
                             info="Certify for Non Visa Arrival/Departure"
                             :redirection_link="getRedirectionLink('non-visa-arrival-departure')"

                             :style="selectedCard=='non-visa-arrival-departure'?styleObject:''"
              ></homepage-item>
              <!--              redirection_link="/non-visa-arrival-departure-certification"-->
              <!--              redirection_link="https://nepaliport-new.immigration.gov.np/non-visa-arrival-departure-certification"-->

              <homepage-item @click.native="selectCard('visa-application-track')"
                             title="Visa Application Track"
                             service_icon="ic_visa_embassy.png"
                             sub_title="To track visa application"
                             info="Track your visa application"
                             :redirection_link="getRedirectionLink('visa-application-track')"
                             :style="selectedCard=='visa-application-track'?styleObject:''"
              ></homepage-item>
              <!--              redirection_link="https://nepaliport-new.immigration.gov.np/visa-application-track"-->
              <!--   redirection_link="/visa-application-track"           -->



              <homepage-item @click.native="selectCard('visa-check')"
                             title="Check Visa"
                             service_icon="ic_visa_embassy.png"
                             sub_title="To check visa issued by Nepal"
                             info="Check visa issued by Nepal"
                             :redirection_link="getRedirectionLink('visa-check')"

                             :style="selectedCard=='visa-check'?styleObject:''"
              ></homepage-item>
              <!--              redirection_link="/visa-check"-->
              <!--              redirection_link="https://nepaliport-new.immigration.gov.np/visa-check"-->

            </div>
            <div class="row mt-2">
              <!--              <div class="col-12 text-center">-->
              <!--                <span class="homepage-service-name-panel text-uppercase">Online Trekking Permit</span>-->
              <!--              </div>-->

              <homepage-item @click.native="selectCard('trekking-permit-check')"
                             title="Check Trekking Permit"
                             service_icon="ic_visa_embassy.png"
                             sub_title="To check trekking permit issued by Nepal"
                             info="Check trekking permit issued by Nepal"
                             :redirection_link="getRedirectionLink('trekking-permit-check')"

                             :style="selectedCard=='trekking-permit-check'?styleObject:''"
              ></homepage-item>
              <!--              redirection_link="/permit-check"-->
              <!--              redirection_link="https://nepaliport-new.immigration.gov.np/permit-check"-->


              <homepage-item @click.native="selectCard('trekking-agency')"
                             title="Trekking Agency"
                             service_icon="ic_visa_embassy.png"
                             sub_title="Trekking Agency Portal"
                             info="Apply for Trekking Agency"
                             :redirection_link="getRedirectionLink('trekking-agency')"

                             :style="selectedCard=='trekking-agency'?styleObject:''"
              ></homepage-item>
              <!--              redirection_link="/trekking"-->
              <!--              redirection_link="https://nepaliport-new.immigration.gov.np/trekking/login"-->
              <homepage-item @click.native="selectCard('single-trekking-permit')"
                             title="Individual Trekking Permit"
                             service_icon="ic_visa_embassy.png"
                             sub_title="Apply for individual trekking permit request"
                             info="Apply for individual trekking permit request"
                             :redirection_link="getRedirectionLink('single-trekking-permit')"
                             :style="selectedCard=='single-trekking-permit'?styleObject:''"
              ></homepage-item>
              <!--              redirection_link="/trekking/single-trekking-request/apply"-->
              <!--              redirection_link="https://nepaliport-new.immigration.gov.np/trekking/single-trekking-request/apply"-->


              <homepage-item @click.native="selectCard('card-payment-site')"
                             title="Card Payment "
                             service_icon="card.svg"
                             sub_title="Pay via your card from anywhere"
                             info="Pay via Your Card"
                             :redirection_link="getRedirectionLink('card-payment-site')"
                             :style="selectedCard == 'official-immigration-site' ? styleObject: ''"
              ></homepage-item>
                            <homepage-item @click.native="selectCard('official-immigration-site')"
                                           title="Department of Immigration"
                                           service_icon="ic_online.png"
                                           sub_title="Official Website of Immigration Nepal"
                                           info="Official Website of Immigration Nepal"
                                           redirection_link="https://www.immigration.gov.np/"
                                           :style="selectedCard == 'official-immigration-site' ? styleObject: ''"
                            ></homepage-item>

              <homepage-item @click.native="selectCard('service-provider-portal')"
                             title="Service Provider"
                             service_icon="card.svg"
                             sub_title="Service Provider Portal"
                             info="Foreign Nationals Management Information System"
                             :redirection_link="getRedirectionLink('service-provider-portal')"
                             :style="selectedCard == 'service-provider-portal' ? styleObject: ''"
              ></homepage-item>

            </div>


          </div>
        </v-card-text>
      </v-card>
      <v-dialog v-model="showDialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">Choose your entry point</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-autocomplete
                      :items="offices"
                      item-text="name"
                      item-value="slug"
                      label="Select Entry Point"
                      v-model="selectedEntryPoint"
                      outlined
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click.stop="showDialog = false;selectedEntryPoint=''">Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <developed-by-item></developed-by-item>
  </div>
</template>

<script>
import {NEPAL_SARKAR_LOGO, NEPALIPORT_LOGO_URL} from "../constant/appConstant";
import DevelopedByItem from "../components/DevelopedBy";
import HomepageItem from "../components/HomepageItem";
import Http from "axios";
import {VERSIONED_API_URL} from "../config/config";


export default {
  components: {DevelopedByItem, HomepageItem},
  data() {
    return {
      sarkarLogo: NEPAL_SARKAR_LOGO,
      logoUrl: NEPALIPORT_LOGO_URL,
      showDialog: false,
      snackbar: {
        show: false,
        text: '',
        color: 'success'
      },
      selectedEntryPoint: '',
      selectedCard: '',
      styleObject: {},
      dynamicRoutes: [],
      // fallback static map (used only when API fails or a route is missing)
      staticRoutes: {
        'visa-from-mission': '/onlinevisa-mission/application',
        'eta-visa-processing': '/eta-visa-processing',
        'visa-extension': '/visa-processing?tab=tab-extend',
        'visa-conversion': '/visa-processing?tab=tab-change',
        'visa-transfer': '/visa-processing?tab=tab-transfer',
        'entry-visa': '/entry-visa-processing',
        'visa-plan-upgrade': '/visa-processing?tab=tab-upgrade',
        'arrival-departure': '/visa-processing?tab=tab-arrival',
        'non-visa-arrival-departure': '/non-visa-arrival-departure-certification',
        'visa-application-track': '/visa-application-track',
        'visa-check': '/visa-check',
        'trekking-permit-check': '/permit-check',
        'trekking-agency': '/trekking',
        'single-trekking-permit': '/trekking/single-trekking-request/apply',
        'official-immigration-site': 'https://www.immigration.gov.np/',
        'card-payment-site':'https://nepaliport-new.immigration.gov.np/card-payment',
        'service-provider-portal':'https://nepaliport-new.immigration.gov.np/service-provider/login'
      }
    }
  },
  async mounted() {
    await this.$store.dispatch('fetchOffices');
    await this.getActiveDynamicRoutes();
  },
  computed: {
    offices() {
      return this.$store.state.Office.offices;
    },
    frontendBaseUrl() {
      return window.location.origin;
    },
  },
  methods: {
    selectCard(cardId) {
      this.selectedCard = cardId;

      this.styleObject = { 'border-style': 'solid' };

      const link = this.getRedirectionLink(cardId);
      if (link && link !== '#') {
        if (link.startsWith('http')) {
          window.open(link, '_blank');
        } else {
          this.$router.push(link).catch(() => {});
        }
      }
    },
    showOfficeDialog(item) {
      this.selectedCard = item
      this.styleObject = "border-style:solid"
      this.showDialog = true;
    },
    async getActiveDynamicRoutes() {
      try {
        const res = await Http.get(VERSIONED_API_URL + '/active-dynamic-routes');


        if (res.data && Array.isArray(res.data.data)) {
          this.dynamicRoutes = res.data.data.map(item => ({
            id: item.id,
            label: item.route_name,
            redirection_link: item.route_url,
          }));
        } else {
          console.warn('Unexpected API response format:', res.data);
          this.dynamicRoutes = [];
        }
      } catch (error) {
        console.error('Failed to fetch active dynamic routes:', error);
        this.dynamicRoutes = [];
        this.snackbar = {
          show: true,
          text: "Failed to load routes.",
          color: "error",
        };
      }
    },
    getRedirectionLink(cardId) {
      const dyn = this.dynamicRoutes.find(r => r.label === cardId);

      if (dyn && dyn.redirection_link) {
        return dyn.redirection_link;
      }

      return this.staticRoutes[cardId] || '#';
    },
  },
  watch: {
    "selectedEntryPoint": function (newValue) {
      if (newValue != '') {
        this.showDialog = false
        window.open(`${this.frontendBaseUrl}/on-arrival/` + newValue, '_blank')
      }
    }
  }
}
</script>
